import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';

/** One fiche left by clicking a row of the "Lié à" panel. */
export interface LinkTrailStep {
  type: LinkableEntityType;
  id: string;
  title: string;
  path: string;
}

export const LINK_TRAIL_MAX_STEPS = 5;

/**
 * The trail travels in `location.state` from one fiche to the next, so arriving from a menu
 * (no state) naturally starts from an empty trail, and a page reload drops it.
 */
export const readLinkTrail = (state: unknown): LinkTrailStep[] => {
  const trail = (state as { linkTrail?: unknown } | null)?.linkTrail;
  return Array.isArray(trail) ? (trail as LinkTrailStep[]) : [];
};

export const extendLinkTrail = (trail: LinkTrailStep[], step: LinkTrailStep): LinkTrailStep[] =>
  [...trail, step].slice(-LINK_TRAIL_MAX_STEPS);
